import { getImportQueue } from 'RestAPIs/import-queue';

import { BaseQueue } from 'components/admin-portal/queues/BaseQueue';

const ImportQueue = () => {
  const columns = [
    'id',
    'tenantId',
    'status',
    'inserted',
    'started',
    'ended',
    'externalId',
    'type',
    'employer'
  ];

  return (
    <BaseQueue
      queueName="importQueue"
      columns={columns}
      getBaseQueue={getImportQueue}
    />
  );
};

export default ImportQueue;
